import { Box } from "@mui/material";
import CustomButton from "Components/shared/Button";
import { useRTL } from "hooks/isRTL";
import SearchBar from "Components/shared/SearchBar";
import ExportButton from "Components/shared/ExportButton";

const CustomerSearch = ({
  setFilters,
  setDescendingNameSort,
  setPage,
  searchValue,
  onSearchChange,
}) => {
  const { t } = useRTL();

  const handleClearFilters = () => {
    const clearedFilters = {
      fullName: "",
      phoneNumber: "",
      email: "",
      status: [],
    };

    setDescendingNameSort(null);
    setPage(0);
    setFilters(clearedFilters);
    onSearchChange("");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        gap: "16px",
        borderRadius: "8px",
        alignItems: "center",
        marginBottom: "5px",
        backgroundColor: "white",
        padding: "16px",
      }}
    >
      <Box sx={{ flex: 1, maxWidth: "350px" }}>
        <SearchBar
          value={searchValue}
          onSearch={onSearchChange}
          placeholder={t("searchCustomersByName")}
        />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <CustomButton onClick={handleClearFilters}>
          {t("clearFilters")}
        </CustomButton>
        <ExportButton reportType="CustomerManagement" />
      </Box>
    </Box>
  );
};

export default CustomerSearch;
